window.upi = Object.assign( {}, window.upi || {} );

function namespace ( ns_str, scope ) {
    let parts = ns_str.split( '.' ),
        parent = scope || window.upi;

    // filter redundant ns global
    if ( parts[i] === 'upi' ) {
        parts = parts.slice( 1 );
    }

    for ( var i = 0, l = parts.length; i < l; i++ ) {
        // create ns if not exists
        if ( typeof parent[parts[i]] === 'undefined' ) {
            parent[parts[i]] = {};
        }
        parent = parent[parts[i]];
    }

    return parent;
}

export default namespace;

window.upi.namespace = namespace;



